import Grid, { GridSize } from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import type { SxProps } from "@mui/material/styles";

import { kebabCase } from "lodash";

type PatientReviewDetailGroupTitleProps = {
  title?: string;
  sx?: SxProps;
  xs?: boolean | GridSize;
  sm?: boolean | GridSize;
  md?: boolean | GridSize;
  lg?: boolean | GridSize;
};

export default function PatientReviewDetailGroupTitle({
  title,
  sx,
  xs = 12,
  sm = 12,
  md = 6,
  lg = 2
}: PatientReviewDetailGroupTitleProps) {
  return (
    <Grid
      item
      xs={xs}
      sm={sm}
      md={md}
      lg={lg}
      sx={sx}
      paddingRight={1}
      paddingTop={1}
      paddingBottom={1}
      data-testid={`review-detail-group-title-${kebabCase(title)}`}
    >
      {Boolean(title) ? (
        <Typography
          fontSize={16}
          fontWeight={700}
          textTransform="uppercase"
          letterSpacing="0.08em"
          sx={{ pt: 1, pb: 1, pl: 0 }}
        >
          {title}
        </Typography>
      ) : null}
    </Grid>
  );
}
